export default __webpack_public_path__ + "/dist/images/how-to-help.591460b9aa4bc45da7ec33ec1ba008ed.png";